/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProductWithPricesDto } from './ProductWithPricesDto';
export type OrganizationWithPlanAndListCountDto = {
    listCount: number;
    plan: ProductWithPricesDto;
    id: string;
    name: string;
    website: string | null;
    onboarding_step: OrganizationWithPlanAndListCountDto.onboarding_step;
    is_enterprise: boolean;
    did_enterprise_kickoff: boolean;
    has_ai_product: boolean;
};
export namespace OrganizationWithPlanAndListCountDto {
    export enum onboarding_step {
        ORGANIZATION_DATA = 'ORGANIZATION_DATA',
        FINISHED = 'FINISHED',
    }
}

